import { useEffect, useState } from "react";
import { getPersonasList } from "../services/course";

const useFetchPersonas = () => {
  const [personas, setPersonas] = useState([]);

  useEffect(() => {
    const fetchPersonasData = async () => {
      try {
        const response = await getPersonasList();

        if (response && Array.isArray(response.items)) {

          setPersonas(response.items);
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchPersonasData();
  }, [setPersonas]);

  return (
    {personas}
  )
}
export default useFetchPersonas;